<template>
  <div :class="{footer: true, second: isSecond, third: isThird}" @click="$emit('open-chat')">
      <div :class="{'footer-container': true, active: isActive}">
      <div class="footer-wrapper">
        <div class="message-counter" v-if="newMessages > 0"><b>{{newMessages}}</b></div>
        <div class="room-avatar" :style="{'background-image': backgroundUrl}"></div>
        <div class="name-wrapper">
          <div class="name-text">{{name}}</div>
        </div>
      </div>
        <div style="max-height: 30px;
    display: flex;">
          <window-maximize class="icon-1_5x" fillColor="#16aa13" :size="72" style="color: black" ></window-maximize>
        </div>
      </div>
  </div>
</template>

<script>
import WindowMaximize from 'vue-material-design-icons/WindowMaximize.vue'
export default {
  name: "TaskMessagingFooter",
  components: {
    WindowMaximize
  },
  props: {
    newMessages: Number,
    isSecond: Boolean,
    isThird: Boolean,
    name: {
      type: String,
      default: "Nachrichten"
    },
    isActive: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    backgroundUrl() {
      return this.name === 'Aufgaben Chat' ? "url(/ic_task_int.png)": "url(/ic_task.png)";
    },
  }
}
</script>

<style scoped>
.footer {
  height: 60px;
  width: 15vw;
  min-width: 300px;
  position: fixed;
  bottom: 0px;
  right: 32px;
  cursor: pointer;
  transition: all .2s;
  z-index: 100
}

.second {
  right: max(20vw, 364px) !important;
}

.third {
  right: max(39vw, 700px) !important;
}

.footer-container {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  padding: 0 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.footer .active {
  background-color: #4DBD74;
}

.footer-wrapper {
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
  height: 100%;
}

.message-counter {
  background-color: #ff0000;
  height: 25px;
  width: 25px;
  min-height: 25px;
  min-width: 25px;
  margin-right: 15px;
  border-radius: 50%;
  text-align: center;
  line-height: 26px;
  color: white;
}
.name-wrapper {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.name-text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 17px;
  font-weight: 500;
  line-height: 22px;
}

.room-avatar {
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 35px;
  width: 35px;
  min-height: 35px;
  min-width: 35px;
  margin-right: 10px;
}
</style>
